/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/display-name */

import React, { forwardRef } from 'react'
import { Link } from 'react-router-dom'

import PIIPopup from '../page-overlay/pii-popup'
import './formvalidation-msgs.css'
import {
  ForSelforOtherValidationsMsgData,
  InquiryFormValidationMsgData,
} from './inquiry-form-validation-msgs-data'

interface InquiryFormValidationMsgProps {
  displayPII: any
  inputValidationObj: any
  piiScan: any
  popupCloseOpenFunctionality: any
  ref: any
  selfForOther: any
  setExpandDetailsAccordion: any
  setPIIScan: any
  setSelfForOther: any
  updateClickPosition: 'bottom' | 'top'
  validref: any
}

const InquiryFormValidationMsgs = forwardRef<HTMLDivElement, InquiryFormValidationMsgProps>(
  (
    {
      displayPII,
      inputValidationObj,
      piiScan,
      popupCloseOpenFunctionality,
      selfForOther,
      setExpandDetailsAccordion,
      setPIIScan,
      setSelfForOther,
      updateClickPosition, // This prop can be removed since `ref` is now being passed from forwardRef
    },
    ref // The forwarded ref
  ) => {
    const getInvalidInputs = (validationObj: any) => {
      const keys = Object.keys(validationObj)
      const sortedInputs: any[] = Object.values(validationObj)
        .map((entry: any, index: number) => ({
          ...entry,
          name: keys[index],
        }))
        .sort((a: any, b: any) => a?.order - b?.order)
      return sortedInputs.filter((entry) => !entry.isValid)
    }

    const showHideCancel = () => {
      if (updateClickPosition === 'top' || updateClickPosition === 'bottom') {
        popupCloseOpenFunctionality('Close', updateClickPosition)
        setPIIScan({})
      }
      // Reset error validations
      setExpandDetailsAccordion(false)
      if (selfForOther) {
        setSelfForOther({
          ...selfForOther,
          DoDForOther: { isValid: true },
          DoDNumberSelf: { isValid: true },
          EmailChange: {isValid: true},
          EmailForOther: { isValid: true },
        })
      }
    }

    const handleValidationClick = (key: string) => {
      setExpandDetailsAccordion(false)

      const validKeys = [
        'Description',
        'Subject',
        'CategoryCode',
        'SectionCode',
      ]

      if (validKeys.includes(key)) {
        setExpandDetailsAccordion(true)
      }

      setTimeout(() => {
        if (key === 'Description') {
          inputValidationObj[key].link.current?.focusEditor()
        } else {
          inputValidationObj[key].link.current?.focus()
        }
      }, 100) // Waits for accordion to expand before referencing to focus
    }

    const selfForOtherValidation = getInvalidInputs(selfForOther)
    const invalidInputs = getInvalidInputs(inputValidationObj)

    return (
      <div
        className='pt-2 validation-msgs mb-3 py-2 ps-2 whitebg shadow text-color5 bordered7 border-radius p-relative'
        ref={ref} // Forwarded ref is attached here
      >
        {displayPII && (
          <>
            <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />
            <button
              aria-label='Close'
              className='anchorclosebutton py-2 px-2 bgcolor-primary whitetext btn-border-radius3'
              onClick={showHideCancel}
              title='Close'
              type='button'
            >
              <span className='icon-close text-color1 font-10'></span>
            </button>
          </>
        )}
        {(selfForOtherValidation.length > 0 ||
          (invalidInputs.length > 0 && displayPII === false)) && (
          <>
            <h2 className='px-2 title-color1 font-15 sourcesansprosemibold text-uppercase'>
              <span aria-label='Please Fill The Below Mandatory Fields' tabIndex={0}>
                PLEASE FILL THE BELOW MANDATORY FIELDS
              </span>
            </h2>
            <button
              aria-label='Close'
              className='anchorclosebutton py-2 px-2 bgcolor-primary whitetext btn-border-radius3'
              onClick={showHideCancel}
              title='Close'
              type='button'
            >
              <span className='icon-close text-color1 font-10'></span>
            </button>
            <ul
              aria-live='polite'
              className='marker-color list-type-circle font-13 sourcesanspro'
              tabIndex={0}
            >
              {selfForOtherValidation.map((input) => {
                if (ForSelforOtherValidationsMsgData[input.name]) {
                  return (
                    <li key={input.name}>
                      <Link
                        title={input.name}
                        to={ForSelforOtherValidationsMsgData[input.name]?.link}
                      >
                        {ForSelforOtherValidationsMsgData[input.name]?.title}
                      </Link>
                    </li>
                  )
                }
              })}

              {selfForOther.DoDForOther.isValid &&
                selfForOther.EmailForOther.isValid &&
                selfForOther.EmailChange.isValid &&
                invalidInputs.map((input) => {
                  if (InquiryFormValidationMsgData[input.name]) {
                    return (
                      <li key={input.name}>
                        <Link
                          onClick={(e: any) => {
                            e.preventDefault()
                            handleValidationClick(input.name)
                          }}
                          title={input.name}
                          to={InquiryFormValidationMsgData[input.name]?.link}
                        >
                          {InquiryFormValidationMsgData[input.name]?.title}
                        </Link>
                      </li>
                    )
                  }
                })}
            </ul>
          </>
        )}
      </div>
    )
  }
)

export default InquiryFormValidationMsgs
